import { RecipeDietTypes, UserDietTypes } from "../search/search.types";
import { IngredientsTableInterface } from "./homepage.types";

export const ingredientsObjectAdapter = (ingredients: Array<IngredientsTableInterface>) => {
  const ingredientsObject: Record<string, IngredientsTableInterface> = ingredients.reduce((prev: Record<string, IngredientsTableInterface>, next: IngredientsTableInterface) => ({
    ...prev, [next.id]: {
      ...next,
      preps: next.preps.reduce((p: any, n: any) => ({ ...p, [n.prepId]: n }), {}),
    },
  }), {});
  return ingredientsObject
}

export const dietFilter = (userDiet: string, recipeDiet: string[]) => {
  const dietTypes: Record<string, boolean> = {
    [RecipeDietTypes.VEGAN]: false,
    [RecipeDietTypes.VEG]: false,
    [RecipeDietTypes.EGG]: false,
  };

  recipeDiet.forEach(type => {
    if (type in dietTypes) dietTypes[type] = true
  });

  const includesVegan = dietTypes[RecipeDietTypes.VEGAN];
  const includesVeg = dietTypes[RecipeDietTypes.VEG];
  const includesEgg = dietTypes[RecipeDietTypes.EGG];

  if (userDiet === UserDietTypes.VEGAN) {
    return includesVegan
  }
  if (userDiet === UserDietTypes.VEG) {
    return includesVegan || includesVeg
  }
  if (userDiet === UserDietTypes.EGG) {
    return includesVegan || includesVeg || includesEgg
  }
  return true;
}

export const allergenFilter = (userAllergens: string[], recipeAllergens: string[]) => userAllergens?.some((i: any) => recipeAllergens.includes(i))
